
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'WhatsappIntroStep',

  setup() {
    const { t } = useI18n();
    const benefitKeys = [
      'storeParameters.services.whatsappBusinessParameter.notConnected.benefit1',
      'storeParameters.services.whatsappBusinessParameter.notConnected.benefit2',
      'storeParameters.services.whatsappBusinessParameter.notConnected.benefit3',
    ];
    return { t, benefitKeys };
  },
});
